import { render, staticRenderFns } from "./WorkerList.vue?vue&type=template&id=10132cfb&scoped=true"
import script from "./WorkerList.vue?vue&type=script&lang=js"
export * from "./WorkerList.vue?vue&type=script&lang=js"
import style0 from "./WorkerList.vue?vue&type=style&index=0&id=10132cfb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10132cfb",
  null
  
)

export default component.exports